/**
 * @file The My tasks query over `forms`: the forms assigned to the user, most
 * recently modified first, at most `HOME_MY_TASKS_LIMIT`. Consumer:
 * `useHomeMyTasks`. The rules allow this list only for `formsRead` or
 * `formsWrite`; an access-group-only reader is denied. The composite index on
 * `assignedTo` ascending and `meta.lastModified` descending in
 * `firestore.indexes.json` serves it.
 */
import type { QueryOptions } from '@/store';

import { HOME_MY_TASKS_LIMIT } from './HOME_MY_TASKS_LIMIT';

export const homeMyTasksQuery = (uid: string): QueryOptions => ({
  orderBy: { field: 'meta.lastModified', direction: 'desc' },
  extraConstraints: [
    { type: 'where', field: 'assignedTo', op: '==', value: uid },
    { type: 'limit', n: HOME_MY_TASKS_LIMIT },
  ],
});
